// Service
import { apiServices } from "@core/services/appService";

// @utility
import { buildGroupedLotteriesDynamic } from "@utility/app/lotteryMatch";

// Redux
import { setStatusSpinner } from "@core/redux/actions/app/spinner";

const SET_DATA_REWARD_CODE = 'app/lottery/SET_DATA_REWARD_CODE';
const SET_DATA_REWARD_LIST = 'app/lottery/SET_DATA_REWARD_LIST';
const SET_DATA_REWARD_LIST_TODAY = 'app/lottery/SET_DATA_REWARD_LIST_TODAY';

function setDataRewardList(data) {
    return dispatch => {
        dispatch({
            type: SET_DATA_REWARD_LIST,
            payload: {
                items: data
            }
        })
    }
}

function loadRewardCode(hideProcessing) {
    return dispatch => {
        if (!hideProcessing) {
            dispatch(setStatusSpinner({ status: true, textProcess: null }));
        }

        apiServices({}, "get", `/general/lottery/code-cache/${process.env.REACT_APP_DEFAULT_AGENT_CODE}`).then((data) => {
            dispatch(setStatusSpinner({ status: false, textProcess: null }));
            const statusCode = data.code;

            if (statusCode === 200 || statusCode === 0) {
                const result = data.result;

                dispatch({
                    type: SET_DATA_REWARD_CODE,
                    payload: {
                        items: result
                    }
                })
            }
            else {
                dispatch({
                    type: SET_DATA_REWARD_CODE,
                    payload: {
                        items: null
                    }
                })
            }
        });
    }
}

function loadRewardList(dataJson, processing) {
    return dispatch => {
        if (!processing) {
            dispatch(setStatusSpinner({ status: true, textProcess: null }));
        }

        dispatch({
            type: SET_DATA_REWARD_LIST,
            payload: {
                items: null
            }
        });

        apiServices(dataJson, "post", "/general/lottery-v2/reward").then((data) => {
            dispatch(setStatusSpinner({ status: false, textProcess: null }));
            const statusCode = data.code;

            if (statusCode === 200 || statusCode === 0) {
                const result = data.result;

                // 🔧 จัดกลุ่มก่อนเซ็ตค่า
                const resultGroups = buildGroupedLotteriesDynamic(result);
                const grouped = [...resultGroups].sort((a, b) => a.category_at - b.category_at);

                dispatch({
                    type: SET_DATA_REWARD_LIST,
                    payload: {
                        items: grouped
                    }
                });
            }
            else {
                dispatch({
                    type: SET_DATA_REWARD_LIST,
                    payload: {
                        items: null
                    }
                });
            }
        });
    }
}

function loadRewardListToday() {
    return dispatch => {
        apiServices({}, "get", `/general/lottery-v2/reward-cache/today/${process.env.REACT_APP_DEFAULT_AGENT_CODE}`).then((data) => {
            const statusCode = data.code;

            if (statusCode === 200 || statusCode === 0) {
                const result = data.result;

                // 🔧 จัดกลุ่มก่อนเซ็ตค่า
                const resultGroups = buildGroupedLotteriesDynamic(result);
                const grouped = [...resultGroups].sort((a, b) => a.category_at - b.category_at);

                dispatch({
                    type: SET_DATA_REWARD_LIST_TODAY,
                    payload: {
                        items: grouped
                    }
                });
            }
            else {
                dispatch({
                    type: SET_DATA_REWARD_LIST_TODAY,
                    payload: {
                        items: null
                    }
                });
            }
        });
    }
}

export {
    loadRewardList,
    loadRewardListToday,
    loadRewardCode,
    setDataRewardList,
    SET_DATA_REWARD_CODE,
    SET_DATA_REWARD_LIST_TODAY,
    SET_DATA_REWARD_LIST
}